<template>
  <v-container fluid>
    <v-layout justify-center>
      <v-card width="100%" >
      <v-flex lg12 pa-5 >
        <v-layout v-if="idubapi.restriccionesCliente.restringirEdicionMaestrosPV != 1">
          <h2 class="primary--text text-uppercase textoAjustado text-center">
            {{localization.create.title}}
          </h2>
        </v-layout>
        <v-divider class="divider_subtitle" v-if="idubapi.restriccionesCliente.restringirEdicionMaestrosPV != 1"/>
        <v-form v-model="valid" id="valid" ref="form" autocomplete="off" v-if="idubapi.restriccionesCliente.restringirEdicionMaestrosPV != 1">
          <v-layout row wrap align-center justify-center>
            <v-flex xs6 sm6 md2 lg2 pl-3 pr-3>
              <v-text-field
                v-if="this.$store.state.configuracion.tipoDatosColumnCode[this.tableName] === 'int'"
                v-model="codigo" id="codigo"
                :label="localization.create.codigo"
                @keypress="isNumber($event)"
                maxlength="10"
                :rules="[rules.integerNumber1]"
              />
              <v-text-field
                v-if="this.$store.state.configuracion.tipoDatosColumnCode[this.tableName] === 'varchar'"
                v-model="codigo" id="codigo"
                :label="localization.create.codigo"
                maxlength="10"
                :rules="[rules.textOnly]"
              />
            </v-flex>
            <v-flex xs12 sm12 md3 lg3 pl-3 pr-3>
              <v-text-field
                v-model="complaintType" id="complaintType"
                :label="localization.create.nombre"
                maxlength="100"
              />
            </v-flex>
            <v-flex v-if="!tipoReclamacionSelectedId" xs12 sm12 md3 lg3 pl-3 pr-3>
              <v-btn
                color="primary"
                :disabled="!this.codigo || !this.complaintType"
                @click="addNewComplaintType()"
              >
                {{localization.create.addButton}}
              </v-btn>
            </v-flex>
            <v-flex v-else xs12 sm12 md3 lg3 pl-3 pr-3>
              <v-btn
                color="primary"
                :disabled="!this.codigo || !this.complaintType"
                @click="editarNewComplaintType()"
              >
                {{localization.create.editar}}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-form>

        <v-layout>
          <h2 class="primary--text text-uppercase textoAjustado text-center">
            {{localization.list.title}}
          </h2>
        </v-layout>
        <v-divider class="divider_subtitle"></v-divider>
        <v-data-table
          :headers="headers"
          :items="complaintTypes"
          class="elevation-1"
          :loading="loading"
          
          :footer-props="{
            'items-per-page-options': [5, 10, 15, 20],
            'items-per-page-text': $t('filasPorPagina'),
          }"
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.id" @click="selectItem(item)" :style="{'background-color': tipoReclamacionSelectedId === item.id ? 'lightgray' : ''}">
                <td class="text-xs-center">{{ item.code }}</td>
                <td class="text-xs-center">{{ item.translates[usuario.idioma] || item.name }}</td>
                <td class="text-xs-center">
                  <v-flex row justify-center>
                    <v-icon
                      class="iconSize"
                      small
                      @click="openTranslateDialog(item.id)"
                      >mdi-web</v-icon
                    >
                    <v-icon class="iconSize" small @click="openDialog(item.id)" v-if="idubapi.restriccionesCliente.restringirEdicionMaestrosPV != 1">delete</v-icon>
                  </v-flex>
                </td>
              </tr>
            </tbody>
            <ConfirmDialog @close="deleteItem()" :text="textDialog"
              @cancel="dialog = false" :dialogFlag="dialog" 
              :textoTitulo="$t('eliminar')" :textoBoton="$t('eliminar')" />
            <TranslatePopUp
                ref="TranslatePopUp"
                :translateFlag="translateDialog"
                @cancel="translateDialog = false"
                @save="guardarTraduccion($event)"
                :idMaestro="idMaestro"
                :tipoMaestro="tipoMaestro"
              />
          </template>
        </v-data-table>
      </v-flex>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ConfirmDialog from '../../custom/confirmDialog'
import inputNumber from '@/mixins/inputNumber'
import rulesMixin from "@/components/generic/rules.js";
import TranslatePopUp from "../../custom/translatePopUp.vue";

export default {
  mixins: [inputNumber, rulesMixin],
  components: {
    ConfirmDialog,
    TranslatePopUp
  },
  data () {
    return {
      textDialog: '¿Está seguro que desea eliminar el elemento seleccionado?',
      codigo: null,
      dialog: false,
      itemToDeleteId: null,
      complaintType: null,
      loading: false,
      tipoReclamacionSelectedId: null,
      tableName: 'pv_tiposReclamacion',
      translateDialog: false,
      idMaestro: null,
      tipoMaestro: null
    }
  },
  computed: {
    ...mapGetters({
      idubapi: 'login/idubapi'
    }),
    headers () {
      return [
        { text: this.localization.list.codigo, value: 'code', sortable: true, align: 'left' },
        { text: this.localization.list.nombre, value: 'name', sortable: true, align: 'left' },
        { text: this.localization.list.opciones, value: 'delete', sortable: false, align: 'center' }
      ]
    },
    translates() {
      if (this.$store.state.incidencias.translates) {
        return this.$store.state.incidencias.translates;
      }
      return [];
    },
    usuario() {
      return JSON.parse(localStorage.getItem('usuario'))
    },
    localization () {
      return this.$t('maestros.tiposReclamacion')
    },
    complaintTypes () {
      if (this.$store.state.incidencias.complaintTypes) {
        // return this.$store.state.incidencias.complaintTypes
        return this.sortItemsByField(this.$store.state.incidencias.complaintTypes,'name')
      }
      return []
    }
  },
  mounted () {
    this.loading = true
    this.getComplaintTypes()
      .then(() => {
        this.loading = false
      })
      .catch(e => {
        this.loading = false
        return e
      })

    let object = {
      'table': this.tableName,
      'column': 'codigo'
    }
    this.obtenerTipoDatosColumna(object)
      .then(() => {
        this.loading = false
      })
      .catch(e => {
        this.loading = false
        return e
      })
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      getComplaintTypes: 'incidencias/getComplaintTypes',
      addComplaintType: 'incidencias/addComplaintType',
      updateComplaintType: 'incidencias/updateComplaintType',
      checkUsado: 'incidencias/comprobarComplaintTypeAsignado',
      delComplaintType: 'incidencias/delComplaintType',
      obtenerTipoDatosColumna: 'configuracion/obtenerTipoDatosColumna',
      saveTranslates: "incidencias/updateTranslates"
    }),
    async openTranslateDialog(id) {
      
      this.tipoMaestro = "tiposReclamacion";
      this.loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel,
      });
      this.loader.hide();
      this.$refs.TranslatePopUp.getTranslates()
      this.idMaestro = id;
      this.translateDialog = true;
    },
    async guardarTraduccion(traducciones) {
      let tipoMaestro = "tiposReclamacion";
      this.loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel,
      });
      await this.saveTranslates({
        idMaestro: this.idMaestro,
        tipoMaestro: tipoMaestro,
        traducciones: traducciones,
      });
      await this.getComplaintTypes()
      this.loader.hide();
      this.translateDialog = true;
    },
    async comprobarUsado (id) {
      let response = await this.checkUsado(id)
      if (response === 'KO') {

        const puedeBorrar = this.$store.state.configuracion.configuracion.PV_PERMITIR_BORRAR_MAESTROS_CON_INCI
        if(!puedeBorrar) {
          this.addAlert({texto: this.$t('no_puede_borrar_maestros'), color: 'error'})
          return
        }
        
        this.textDialog = this.$t('estaSeguroEliminarElementoTieneSolicitudes') 
      } else {
        this.textDialog = this.$t('estaSeguroEliminarElemento')
      }
      this.openDialog(id)
    },
    selectItem (item) {
      if (!this.tipoReclamacionSelectedId || this.tipoReclamacionSelectedId !== item.id) {
        this.tipoReclamacionSelectedId = item.id
      } else {
        this.tipoReclamacionSelectedId = null
      }
    },
    openDialog (itemId) {
      this.dialog = true
      this.itemToDeleteId = itemId
    },
    deleteItem () {
      this.loading = true
      this.delComplaintType(this.itemToDeleteId)
        .then(() => {
          this.getComplaintTypes()
          this.loading = false
          this.addAlert({texto: this.$t('baja_correcta'), color: 'success'})
        })
        .catch(e => {
          this.loading = false
          return e
        })
      this.dialog = false
    },
    async addNewComplaintType () {

      try {

        this.$refs.form.validate()
        if (!this.valid) {
          this.addAlert({texto: 'Por favor, revise los campos marcados en rojo', color: 'error'})
        } else {
          this.loader = this.$loading.show({
            // Optional parameters
            container: this.fullPage ? null : this.$refs.formContainer,
            canCancel: false,
            onCancel: this.onCancel
          })
          const newComplaint = {
            code: this.codigo,
            name: this.complaintType,
            idioma: this.usuario.idioma,
            tipoMaestro: 'tiposReclamacion'
          }
          await this.addComplaintType(newComplaint)
          this.codigo = null
          this.complaintType = null
          await this.getComplaintTypes()
          this.loader.hide()
          this.addAlert({texto: this.$t('alta_correcta'), color: 'success'})
        }
      } catch (error) {
        this.loader.hide()
        this.addAlert({texto: error.message, color: 'error'})
      }
    },
    async editarNewComplaintType () {
      this.loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel
      })
      try {
        const newComplaint = {
          id: this.tipoReclamacionSelectedId,
          code: this.codigo,
          name: this.complaintType,
          idioma: this.usuario.idioma,
          tipoMaestro: 'tiposReclamacion'
        }
        await this.updateComplaintType(newComplaint)
        this.tipoReclamacionSelectedId = null
        await this.getComplaintTypes()
        this.loader.hide()
        this.addAlert({texto: this.$t('alta_correcta'), color: 'success'})
      } catch (error) {
        this.loader.hide()
        this.addAlert({texto: error.message, color: 'error'})
      }
    },
    sortItemsByField(items, field){
     let lista = [...items]

      return lista.sort(function (a, b) {
        if(a === null || typeof a[field] === "undefined" || a[field] === null){
          return 1
        }
        if(b === null || typeof b[field] === "undefined" || b[field] === null){
          return -1
        }
        let x = a[field].trim().toLowerCase()
        let y = b[field].trim().toLowerCase()
        if (x > y) {
          return 1
        }
        if (x < y) {
          return -1
        }
        return 0
      });
    }
  },
  watch: {
    tipoReclamacionSelectedId () {
      if (this.tipoReclamacionSelectedId != null) {
        let parte = this.complaintTypes.find(x => x.id === this.tipoReclamacionSelectedId)
        this.codigo = parte ? parte.code : null
        this.complaintType = parte ? parte.translates[this.usuario.idioma] : null
      } else {
        this.codigo = null
        this.complaintType = null
      }
    }
  }
}
</script>

<style scoped>
.iconSize {
  width: 16px !important;
}
</style>
